import api from '@/api/co.api'
import socket from '@/api/co.socket'
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'

import "dayjs/locale/zh-cn";

let avatar = require('@/assets/profile-avatar.png');

dayjs.locale("zh-cn");
dayjs.extend(relativeTime);

const imMsg = {
  getParams ({
    chatUserId = "",
    type = "",
    search = "",
    searchType = "",
    pageNum = "1",
    pageSize = "10",
    sort = "create_time",
    order = "desc",
    reversed = false,
    caches = [],
    executing = null,
    executed = null
  }) {
    const me = this;
    const obj = {
      url: `${api.url.web_im_msg_record}`,
      data: {
        chatUserId,
        type,
        search,
        searchType,
        pageNum,
        pageSize,
        sort,
        order
      },
      items: caches || [], // 保存已请求到的数据
      reload: false, // 数据是否重新加载
      reversed,
      loadType: 0,
      total: 0,
      executing, // 请求前执行
      executed, // 请求后执行
      transform: me.convertItems
    };

    return obj;
  },

  create ({ data, executing, executed }) {
    api.httpx.create({
      url: api.url.web_im_msg_create,
      data,
      executing,
      executed
    });
  },

  delete ({ id, executing = null, executed = null }) {
    api.httpx.delete({
      url: api.url.web_im_msg_delete,
      id,
      executing,
      executed
    });
  },

  /**
   * 统一的消息发送处理函数
   * @param {Object} options 发送选项
   * @param {string} options.content 消息内容
   * @param {string} options.fromId 发送者ID
   * @param {string} options.toId 接收者ID
   * @param {string} options.contentType 消息类型
   * @param {Function} options.onSuccess 发送成功回调
   * @param {Function} options.onError 发送失败回调
   * @param {Function} options.onComplete 完成回调（无论成功失败）
   * @param {boolean} options.clearInput 是否清空输入框
   * @param {Function} options.setLoading 设置loading状态
   */
  sendMessage (options) {
    const {
      content,
      fromId,
      toId,
      contentType = 'chat',
      onSuccess,
      onError,
      onComplete,
      clearInput = true,
      setLoading
    } = options;

    if (!content || !fromId || !toId) {
      console.error('sendMessage: 缺少必要参数');
      return;
    }

    const messageData = {
      content,
      contentType,
      type: contentType,
      fromId,
      toId
    };

    // 设置loading状态
    if (setLoading) {
      setLoading(true);
    }

    // 先清空输入框（提升用户体验）
    if (clearInput && options.clearInputCallback) {
      options.clearInputCallback();
    }

    const executing = function () {
      // 执行前回调
    };

    const executed = function (res) {
      if (res.status) {
        const data = res.data;
        const message = JSON.stringify({
          ...data,
          createTime: null,
          updateTime: null,
          state: 'ready_send'
        });

        // 发送socket消息
        socket.main.send(message).then((_ev) => {
          console.log('消息发送成功');
          if (onSuccess) {
            onSuccess(data);
          }
        }).catch(_err => {
          console.warn('Socket发送失败:', _err);
          if (onError) {
            onError(_err, 'socket_fail');
          }
        }).finally(() => {
          if (setLoading) {
            setLoading(false);
          }
          if (onComplete) {
            onComplete();
          }
        });
      } else {
        console.warn('消息创建失败:', res);
        if (onError) {
          onError(res, 'create_fail');
        }
        if (setLoading) {
          setLoading(false);
        }
        if (onComplete) {
          onComplete();
        }
      }
    };

    // 创建消息
    this.create({
      data: messageData,
      executing,
      executed
    });
  },

  /**
   * 转换消息项 - 修复历史记录显示问题
   * @param {Object} params 参数对象
   * @param {Array} srcItems 源消息项数组
   * @returns {number} 转换后的消息项数量
   */
  convertItems (params, srcItems) {
    if (!Array.isArray(srcItems)) {
      console.warn('convertItems: srcItems 不是数组', srcItems);
      return 0;
    }

    console.log('convertItems: 开始转换消息项', {
      srcItemsCount: srcItems.length,
      params: params
    });

    let count = 0;
    srcItems.forEach(item => {
      try {
        const dstItem = imMsg.convertItem(item);
        if (dstItem) {
          if (params.reversed) {
            params.items.unshift(dstItem);
          } else {
            params.items.push(dstItem);
          }
          count++;
        }
      } catch (err) {
        console.error('convertItems: 转换消息项失败', { item, error: err });
      }
    });

    console.log('convertItems: 转换完成', {
      originalCount: srcItems.length,
      convertedCount: count,
      finalItemsCount: params.items.length
    });

    return count;
  },

  /**
   * 转换单个消息项
   * @param {Object} srcItem 源消息项
   * @returns {Object} 转换后的消息项
   */
  convertItem (srcItem) {
    if (!srcItem) {
      return null;
    }

    if(srcItem.fromId == '1' && !srcItem.fromAvatar) {
      srcItem.fromAvatar = avatar
    }

    try {
      const from = {
        userId: srcItem.fromId || srcItem.senderId,
        username: srcItem.fromUsername || srcItem.senderUsername,
        mobile: srcItem.fromMobile || srcItem.senderMobile,
        avatar: srcItem.fromAvatar || srcItem.senderAvatar
      };

      const to = {
        userId: srcItem.toId || srcItem.destId,
        username: srcItem.toUsername || srcItem.destUsername,
        mobile: srcItem.toMobile || srcItem.destMobile,
        avatar: srcItem.toAvatar || srcItem.destAvatar
      };

      let content = null;
      let hintTime = "";
      let shortTime = "";

      if (srcItem.type === 'chat' || srcItem.contentType === 'chat') {
        content = srcItem.content;
        if (srcItem.createTime) {
          hintTime = dayjs(srcItem.createTime).format("M月D日 HH:mm");
          shortTime = dayjs(srcItem.createTime).format("MM-DD HH:mm");
        }
      } else {
        try {
          content = api.comm.jsonToObject ? api.comm.jsonToObject(srcItem.content) : srcItem.content;
          if (content && content.operationCreateTime) {
            const ct = parseInt(content.operationCreateTime, 10);
            const msgTime = dayjs(ct).format("YYYY-MM-DD HH:mm");
            hintTime = dayjs(msgTime).fromNow();
            shortTime = dayjs(msgTime).format("MM-DD HH:mm");
            content.hintTime = hintTime;
            content.shortTime = shortTime;
          }
        } catch (err) {
          console.warn('convertItem: 解析content失败', { content: srcItem.content, error: err });
          content = srcItem.content;
        }
      }

      return {
        msgId: srcItem.msgId || srcItem.id,
        type: srcItem.type || srcItem.contentType,
        from,
        to,
        fromId: srcItem.fromId || srcItem.senderId,
        toId: srcItem.toId || srcItem.destId,
        contentType: srcItem.contentType || srcItem.type,
        content,
        state: srcItem.state || 'received',
        createTime: srcItem.createTime,
        updateTime: srcItem.updateTime,
        hintTime,
        shortTime,
        createBy: srcItem.createBy
      };
    } catch (err) {
      console.error('convertItem: 转换失败', { srcItem, error: err });
      return null;
    }
  }
};

export default imMsg;
